//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { SubmissionsConfig } from './SubmissionsConfig';
import { SubmissionFilter } from './SubmissionModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { IssueNotificationType, IssueOrder } from '../Shared/Maint/MaintModels';
import { SubmissionList_Tasks } from './SubmissionList_Tasks';
import { SubmissionList_Merge } from './SubmissionList_Merge';
import { SubmissionList_Comment } from './SubmissionList_Comment';
import { CAMSMap } from '../Extensions/CAMSOLExtensions';
import { IssueTypeModel } from '../Shared/Maint/Entity_Maint';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { Translations } from '../Shared/Models/StaticTranslations';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',

    submissionIssueResponseModal = "#submissionIssueResponseModal",
    submissionIssueResponseNoBtn = '#submissionIssueResponseNoBtn',
    submissionIssueResponseYesBtn = '#submissionIssueResponseYesBtn',
    submissionIssueResponseShowIssueBtn ='#submissionIssueResponseShowIssueBtn',

    taskManagementAssignToModel = '#taskManagementAssignToModel',
    taskManagementAssignToModel_contactSearch = '#taskManagementAssignToModel_contactSearch',
    taskManagementAssignToModelCancelBtn = '#taskManagementAssignToModelCancelBtn',
    taskManagementAssignToModelSubmitBtn = '#taskManagementAssignToModelSubmitBtn'
}

export class SubmissionList {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    public treeView: any;
    public treeData: Array<INode> = [];
    public issueMaxNumberInList: number = 10;
    public issueCountFromServer: number = 0;
    public currentPage: number = 0;
    public pinListFormEl = $('#submissionListPinBtn');
    public currentSortOrder;
    public currentSortDirection: OrderDirection;
    private SubmissionList_Tasks: SubmissionList_Tasks = new SubmissionList_Tasks();
    private SubmissionList_Merge: SubmissionList_Merge;
    private SubmissionList_Comment: SubmissionList_Comment;
    private issueTypeList: Array<IssueTypeModel>;

    // List of buttions in the action toolbar
    public actionBtns = {
        viewprint: { btn: $('#submissionRecordListPrintBtn'), enable: false },
        showmap: { btn: $('#submissionRecordListShowMapBtn'), enable: false },
        reject: { btn: $('#submissionRecordListRejectBtn'), enable: false },
        delete: { btn: $('#submissionRecordListDeleteBtn'), enable: false },
        query: { btn: $('#submissionRecordListQueryBtn'), enable: false },
        duplicate: { btn: $('#submissionRecordListDuplicateBtn'), enable: false },
        changeParent: { btn: $('#submissionRecordListChangeParentBtn'), enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Initiate merge
        self.SubmissionList_Merge = new SubmissionList_Merge(self.map, self);
        self.SubmissionList_Comment = new SubmissionList_Comment(this);

        // On view change
        $('#submissionViewRadioGroup input').on('change', function () { self.submissionViewChanged($(this)); });

        // Hide/show config
        if (SubmissionsConfig.ReportedFurnitureEnabled != true) {
            $('#tmRadio_ReportedFurniture').parent().hide();
        }

        // Bind buttons
        $('#submissionListCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
        });

        // Add pin btn event
        self.pinListFormEl.on("click", function () { Utilities.TogglePinListForm($(this)); });

        $('#submissionRecordFilter').on('change', function () { self.recordFilterSelected(); });
        $('#submissionRecordListPageAmount select').on('change', function () { self.recordListPageAmountSelected(); });
        $('#submissionRecordListSelectAllBtn').on('change', function () { self.recordListSelectAllChecked(); });
        $('#submissionRecordListSearchBtn').on('click', function () { self.GetTreeData(); this.blur(); });
        $('#submissionRecordListShowCustomFilterBtn').on("click", function () { toastr.info("To be completed"); this.blur(); });

        // Action buttons
        this.actionBtns.viewprint.btn.on("click", function () { toastr.info("To be completed"); this.blur(); });
        this.actionBtns.showmap.btn.on("click", function () { self.ZoomToChecked(); this.blur(); });
        this.actionBtns.reject.btn.on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys == null || camsKeys.length == 0 || camsKeys.length > 1) return;
            events.bus.publish(events.eventOpenMaintRejectPanel([camsKeys[0], function (r) {
                if (r.success == true) {
                    self.GetTreeData();
                    self.GetSubmissionCounts();
                    $('#submissionListEditContainer').removeClass('show600');
                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));

                    self.openSubmissionIssueResponseForm(camsKeys[0].code, IssueNotificationType.Rejected);
                }
            }
            ]));
            this.blur();
        });
        this.actionBtns.delete.btn.on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys == null || camsKeys.length == 0 || camsKeys.length > 1) return;

            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                if (r.yes == true) {
                    self.DeleteIssue(camsKeys[0], function (result) {
                        if (result.success == true) {
                            self.GetTreeData();
                            self.GetSubmissionCounts();
                            $('#submissionListEditContainer').removeClass('show600');
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    });
                }
                else {
                }
            }).catch(e => { });

        });
        this.actionBtns.query.btn.on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys == null || camsKeys.length == 0 || camsKeys.length > 1) return;
            events.bus.publish(events.eventOpenNotificationQueryPanel([camsKeys[0], null]));
            this.blur();
        });
        this.actionBtns.duplicate.btn.on("click", function () { toastr.info("To be completed"); this.blur(); });
        this.actionBtns.changeParent.btn.on("click", function () { toastr.info("To be completed"); this.blur(); });

        // Check filters
        self.checkFilters();

        $('#submissionRecordListShowingStartBtn').on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetTreeData();
        });
        $('#submissionRecordListShowingEndBtn').on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetTreeData();
        });
        $('#submissionRecordListShowingNextBtn').on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetTreeData();
        });
        $('#submissionRecordListShowingPrevBtn').on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetTreeData();
        });
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenSubmissionListPanel = (): void => {
        const self = this;

        // Set the default checked 
        if ($("#submissionViewRadioGroup input[type='radio']:checked").length == 0) {
            $("#tmRadio_ReportedIssues").prop('checked', true);
        }

        // Reset the page and focus the individual tasks btn
        this.resetPage();

        $('#submissionListPanel').addClass('show');

        // Get the initial data
        self.GetTreeData();
        self.GetSubmissionCounts();
    }

    public openSubmissionIssueEditForm = (maintCode: string): void => {
        const self = this;

        var showclass = "show600";
        var autoShowList = false;
        if (Utilities.IsListFormPinned(self.pinListFormEl) == false) {
            showclass = "show";
            autoShowList = true;
            $('#submissionListPanel').removeClass('show');
            $('#submissionListEditContainer').removeClass('show600');
        }

        // Load the infra types if required
        if (self.issueTypeList == null) self.loadIssueLUTs();

        $('#submissionListEditContainer').addClass(showclass);
        Utilities.BlockUI($('#submissionListEditContainer'));
        $('#submissionListEditContainer').load(window.G_SITEFOLDERNAME +'/Submissions/IssueEditView', { maintCode: maintCode }, function (response, status, xhr) {
            Utilities.UnBlockUI($('#submissionListEditContainer'));

            $('#submissionIssueEditCloseBtn').on('click', function () {
                $('#submissionListEditContainer').removeClass(showclass);
                if (autoShowList == true) $('#submissionListPanel').addClass('show');
                self.treeView.treeview('unselectAll', { silent: true });
            });

            $('#submissionIssueEditForm #IssueGroupType').on('change', function () { self.issueTypeChanged(); });

            // Bind buttons
            $('#submissionIssueEditForm [data-submission-contactbtn]').on("click", function () {
                let data: ICAMSKey = { code: $('#submissionIssueEditForm [name="LogBy"]').val().toString(), featureType: FeatureType.Contact };
                events.bus.publish(events.eventOpenContactsEditPanel([data, true, null]));
            });
            $('#submissionIssueEditForm [data-submission-zoommaintbtn]').on("click", function () {
                let WKT = $('#submissionIssueEditForm [name="MaintWKT"]').data("maintwkt");
                if (WKT == null) {
                    toastr.info("No geometry associated with this record.");
                }
                else {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[WKT], true, true, FeatureType.Maint]));
                }
                this.blur();
            });
            $('#submissionIssueEditForm [data-submission-zoomparentbtn]').on("click", function () {
                let WKT = $('#submissionIssueEditForm [name="ParentWKT"]').data("parentwkt");
                if (WKT == null) {
                    toastr.info("No geometry associated with this record.");
                }
                else {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[WKT], true, true, FeatureType.Maint]));
                }
                this.blur();
            });
            $('#submissionIssueEditReportedProblemBtn').on("click", function () {
                if ($('#submissionIssueEditForm [name="ReportedProblem"]').prop("disabled") == true) {
                    $('#submissionIssueEditForm [name="ReportedProblem"]').prop("disabled", false);
                    $(this).css('color', 'green');
                }
                else {
                    $('#submissionIssueEditForm [name="ReportedProblem"]').prop("disabled", true);
                    $(this).css('color', 'black');
                }
                this.blur();
            });
            $('#submissionIssueEditCopyReportedIssueBtn').on("click", function () {
                var rp = $('#submissionIssueEditForm [name="ReportedProblem"]').val();
                $('#submissionIssueEditForm [name="Problem"]').val(rp);
            });

            // Photo checkbox buttons
            $('#submissionIssueEditForm [data-fullurl]').on('click', function () {
                const self = this;
                var photoURL = $(this).data('fullurl');

                Utilities.BlockUI();
                $('#placeholder-for-photoModals').load(window.G_SITEFOLDERNAME +'/Photos/ShowPhotoNoModal', { photoURL: photoURL }, function (response, status, xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                    Utilities.UnBlockUI();

                    Utilities.GetModal('#showPhotoModal', ModalAction.Create);
                });
            });
            $('#submissionIssueEditForm [data-photopublish]').on('click', function () {
                var accept = $(this).parent().parent().find('[data-photoaccept]');
                if ($(this).is(':checked') == true) accept.prop('checked', true);
            });
            $('#submissionIssueEditForm [data-photoaccept]').on('click', function () {
                var publish = $(this).parent().parent().find('[data-photopublish]');
                if ($(this).is(':checked') == false) publish.prop('checked', false);
            });

            // Get form validation
            Utilities.InitFormValidation($("submissionIssueEditForm"));

            $('#submissionSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                if ($('#submissionIssueEditForm [name="ReportedProblem"]').val().toString() == "") {
                    toastr.error("The Reported Problem cannot be blank.");
                    return;
                }

                // Validate
                let form: any = $('#submissionIssueEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($('#submissionListEditContainer'));
                let formData = new FormData(<any>$('#submissionIssueEditForm')[0]);

                // Add in photos
                var count = 0;
                $('#submissionIssueEditForm [data-idthumb]').each(function () {
                    formData.set('PhotoItems[' + count + '].idThumb', $(this).data('idthumb'));
                    formData.set('PhotoItems[' + count + '].Publish', $(this).find('[data-photopublish]').is(':checked').toString());
                    formData.set('PhotoItems[' + count + '].Accept', $(this).find('[data-photoaccept]').is(':checked').toString());
                    count++;
                });

                // Manually add in ReportedProblem as this is a disabled field
                formData.set('ReportedProblem', $('#submissionIssueEditForm [name="ReportedProblem"]').val().toString());

                // Add in data for each of the tasks
                //var index = 0;
                //var notificationCount = 0;
                //$('div[name ="taskPanel"]').each(function () {
                //    $(this).find('[name]').each(function () {
                //        formData.append("Tasks[" + index + "]." + $(this).attr('name'), $(this).val().toString());
                //        // Count the number of tasks that will have a notification
                //        if ($(this).attr('name') == "SendNotification" && $(this).is(':checked').toString() == "true") notificationCount++;
                //    });
                //    index++;
                //});

                //if (notificationCount > 0) {
                //    let data: IPromptYesNoViewModel = { title: "Submit", body: notificationCount + " task notification(s) will be sent to users. Proceed?" };
                //    $('#placeholder-for-promptModals').load(window.G_SITEFOLDERNAME +'/PromptModals/PromptYesNoModal', data, function (response, status, xhr) {
                //        $('#promptYesNoModal').modal({ backdrop: 'static', keyboard: false });
                //        $('#promptModalYesBtn').on('click', function (evt) { evt.preventDefault(); $('#promptYesNoModal').modal('hide'); submitForm(); });
                //        $('#promptModalNoBtn').on('click', function (evt) { evt.preventDefault(); $('#promptYesNoModal').modal('hide'); Utilities.UnBlockUI($('#submissionListEditContainer')); });
                //        this.blur()
                //    });
                //}
                //else {
                //    submitForm();
                //}

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.SubmissionsAccept }).then(r => {
                    if (r.yes == true) {
                        submitForm();
                    }
                    else {
                        Utilities.UnBlockUI($('#submissionListEditContainer'));
                    }
                }).catch(e => { });

                function submitForm() {
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Submissions/AcceptIssue',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Updated issue!');
                                    self.GetTreeData();
                                    self.GetSubmissionCounts();
                                    $('#submissionListEditContainer').removeClass(showclass);
                                    if (autoShowList) $('#submissionListPanel').addClass('show');
                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                              
                                    if (result.data.tasksEnabled == true) {
                                        self.SubmissionList_Tasks.openSubmissionIssueEditTaskListModal(maintCode, function () {
                                            self.openSubmissionIssueResponseForm(maintCode, IssueNotificationType.Accepted);
                                        });
                                    }
                                    else {
                                        self.openSubmissionIssueResponseForm(maintCode, IssueNotificationType.Accepted);
                                    }
                                }
                                else {
                                    toastr.error('Failed to update issue!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($('#submissionListEditContainer'));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            $('#submissionMergeBtn').on('click', function (evt) {
                evt.preventDefault();
                $('#submissionListEditContainer').removeClass(showclass);
                $('#submissionListPanel').removeClass('show');
                events.bus.publish(events.eventZoomToAnyFeature([{ code: maintCode, featureType: FeatureType.Maint }, true, null]));
                self.SubmissionList_Merge.mergeWizard_Start({ code: maintCode, featureType: FeatureType.Maint });
            });

            $('#submissionSaveBtn').on('click', function (evt) {
                evt.preventDefault();

                if ($('#submissionIssueEditForm [name="ReportedProblem"]').val().toString() == "") {
                    toastr.error("The Reported Problem cannot be blank.");
                    return;
                }

                Utilities.BlockUI($('#submissionListEditContainer'));
                let formData = new FormData(<any>$('#submissionIssueEditForm')[0]);

                // Manually add in ReportedProblem as this is a disabled field
                formData.set('ReportedProblem', $('#submissionIssueEditForm [name="ReportedProblem"]').val().toString());

                // Add in photos
                var count = 0;
                $('#submissionIssueEditForm [data-idthumb]').each(function () {
                    formData.set('PhotoItems[' + count + '].idThumb', $(this).data('idthumb'));
                    formData.set('PhotoItems[' + count + '].Publish', $(this).find('[data-photopublish]').is(':checked').toString());
                    formData.set('PhotoItems[' + count + '].Accept', $(this).find('[data-photopaccept]').is(':checked').toString());
                    count++;
                });

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.SubmissionsSave }).then(r => {
                    if (r.yes == true) {
                        submitForm();
                    }
                    else {
                        Utilities.UnBlockUI($('#submissionListEditContainer'));
                    }
                }).catch(e => { });

                function submitForm() {
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Submissions/SaveIssue',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Saved issue!');
                                    self.GetTreeData();
                                    self.GetSubmissionCounts();
                                    $('#submissionListEditContainer').removeClass(showclass);
                                    if (autoShowList) $('#submissionListPanel').addClass('show');
                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                }
                                else {
                                    toastr.error('Failed to update issue!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($('#submissionListEditContainer'));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            $('#submissionDeleteBtn').on('click', function (evt) {
                evt.preventDefault();

                Utilities.BlockUI($('#submissionListEditContainer'));
                var camsKey: ICAMSKey = { code: maintCode, featureType: FeatureType.Maint };

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.SubmissionsDeleteIssue }).then(r => {
                    if (r.yes == true) {
                        self.DeleteIssue(camsKey, function (result) {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                self.GetTreeData();
                                self.GetSubmissionCounts();
                                $('#submissionListEditContainer').removeClass(showclass);
                                if (autoShowList) $('#submissionListPanel').addClass('show');
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));

                                self.openSubmissionIssueResponseForm(maintCode, IssueNotificationType.Rejected);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        });
                    }
                    else {
                        Utilities.UnBlockUI($('#submissionListEditContainer')); 
                    }
                }).catch(e => { });

            });

            $('#submissionRejectBtn').on('click', function (evt) {
                evt.preventDefault();

                Utilities.BlockUI($('#submissionListEditContainer'));
                var formData = { MaintCode: maintCode };

                Utilities.UnBlockUI($('#submissionListEditContainer'));
                events.bus.publish(events.eventOpenMaintRejectPanel([{
                    code: maintCode, featureType: FeatureType.Maint
                    }, function (r) {
                        if (r.success == true) {
                            self.GetTreeData();
                            self.GetSubmissionCounts();
                            $('#submissionListEditContainer').removeClass(showclass);
                            if (autoShowList) $('#submissionListPanel').addClass('show');
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));

                            self.openSubmissionIssueResponseForm(maintCode, IssueNotificationType.Rejected);
                        }
                    }
                ]));
            });

            $('#submissionCancelBtn').on('click', function (evt) {
                $('#submissionListEditContainer').removeClass(showclass);
                if (autoShowList) $('#submissionListPanel').addClass('show');
            });

        });

    }

    public openSubmissionIssueCommentForm = (activityUID: string): void => {
        var self = this;
        self.SubmissionList_Comment.openSubmissionIssueCommentForm(activityUID);
    }

    public openSubmissionIssueResponseForm = (maintCode: string, issueNotificationType: IssueNotificationType, fromMaintCode: string = null): void => {
        const self = this;

        var data = { maintCode: maintCode, issueNotificationType: issueNotificationType, fromMaintCode: fromMaintCode };

        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load(window.G_SITEFOLDERNAME +'/Submissions/IssueResponseView', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.submissionIssueResponseModal, ModalAction.Create);
            Utilities.GetControl(jqc.submissionIssueResponseYesBtn).on('click', function (evt) {
                evt.preventDefault();
            });

            Utilities.GetControl(jqc.submissionIssueResponseNoBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueResponseModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.submissionIssueResponseShowIssueBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueResponseModal, ModalAction.Hide);
                var maintCode = $(this).data('maintcode');
                events.bus.publish(events.eventOpenMaintEditPanel({code: maintCode, featureType: FeatureType.Maint}));
            });


            // Send the notification
            sendAcceptNotification();
            function sendAcceptNotification() {
                $.ajax({
                    type: "POST",
                    url: window.G_SITEFOLDERNAME + '/Maint/SendNotificationsToMaintContacts',
                    data: data,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_NotificationSent" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); else toastr.info('Notifications sent!'); });
                            }
                            else {
                                if (result.message == null) toastr.error('Failed to send notifications!');
                                else toastr.error(result.message)
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                });
            }
        });

    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTreeData = (): void => {
        const self = this;

        if ($('#tmRadio_IssueComments').is(':checked')) {
            self.SubmissionList_Comment.GetTreeData();
            return;
        }


        // Get the selected view
        let viewName = "";
        let filterDef: IFilterDefinitionModel = $('#submissionRecordFilter').children("option:selected").data('filterdefinition');
        if (filterDef != null) { viewName = filterDef.viewName; }

        let url = window.G_SITEFOLDERNAME + "/Submissions/GetSubmissionTreeData";
        let query = {
            data: { viewName: viewName, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList }
        };

        Utilities.BlockUI($('#submissionListResultsContainer'));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.DeleteAllNodes();

                        // Create tree
                        var data = result.data.nodes as Array<INode>;
                        self.createTreeData(data);
                        self.createTree(self.treeData, true);
                        self.createTreeHeader();

                        // Update UI
                        self.updatePagingUI();
                        self.checkVisibleButtons();

                        // Update count
                        var countStr = "";
                        if (result && result.data && result.data.totalCount) {
                            countStr = " (" + result.data.totalCount + ")";
                            self.issueCountFromServer = result.data.totalCount;
                        }
                        //$("#submissionSelectedView_TitleCount").html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#submissionListResultsContainer'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public GetSubmissionCounts = (): void => {
        const self = this;

        let url = "/Submissions/GetSubmissionCount";
        let query = {
            Filters: [
                SubmissionFilter.IssueComments, SubmissionFilter.ReportedFurniture, SubmissionFilter.ReportedIssues
            ]
        };

        Utilities.BlockUI($('#submissionListResultsContainer'));
        $.post(url, query, function (response: IAPIResult) {
            try {
                if (response.data.filters != null) {
                    let filters = JSON.parse(response.data.filters);
                    Object.keys(filters).forEach(f => {
                        switch (SubmissionFilter[f]) {
                            case SubmissionFilter.ReportedIssues:
                                $('#submissionListContainer [name="tmRadio_ReportedIssuesCount"]').html(filters[f]);
                                break;
                            case SubmissionFilter.IssueComments:
                                $('#submissionListContainer [name="tmRadio_IssueCommentsCount"]').html(filters[f]);
                                break;
                            case SubmissionFilter.ReportedFurniture:
                                $('#submissionListContainer [name="tmRadio_ReportedFurnitureCount"]').html(filters[f]);
                                break;
                        }
                    });
                }
            }
            catch (err) {
                console.log(err);
                alert(err);
            }
            finally {
                Utilities.UnBlockUI($('#submissionListResultsContainer'));
            }
        });
    }

    private DeleteIssue = (camsKey: ICAMSKey, callback: Function): void => {
        const self = this;

        $.post('/Maint/DeleteIssue', camsKey,
            function (result: IAPIResult) {
                callback(result);
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private recordFilterSelected = (): void => {
        this.resetPage();
        this.GetTreeData();
    }

    private recordListPageAmountSelected = (): void => {
        this.issueMaxNumberInList = $('#submissionRecordListPageAmount select').children("option:selected").val() as number;
        this.GetTreeData();
    }

    private recordListSelectAllChecked = (): void => {
        const self = this;
        if ($('#submissionRecordListSelectAllBtn').is(":checked") == true) {
            self.treeView.treeview('checkAll', { silent: true });
        }
        else {
            self.treeView.treeview('uncheckAll', { silent: true });
        }
        self.checkVisibleButtons();
    }

    private submissionViewChanged = (el: JQuery<HTMLElement>): void => {
        // Set css
        $("#tmRadio_ReportedIssues").parent().removeClass('active');
        $("#tmRadio_IssueComments").parent().removeClass('active');
        $("#tmRadio_ReportedFurniture").parent().removeClass('active');
        el.parent().addClass('active');
   
        this.resetPage();

        // Update filters
        this.checkFilters();

        // Get data for the tree
        this.GetTreeData();
    }


    // ----------------------------------------------------------- //
    // CREATE/ADD TREE
    public createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#submissionListTreeResults');
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: true,
            multiSelect: false,
            highlightSelected: true,
            onNodeSelected: function (event, node) {
                //// Zoom to WKT, but only if its not a TaskGroup
                //if (node.WKT) {
                //    events.bus.publish(events.eventZoomToWKTandHighlight([[node.WKT], true, true]));
                //}
                //else {
                //    if (node.featureType != FeatureType.TaskGroup) toastr.info('The record has no associated map feature')
                //}

                // Check buttons
                self.showHideEditForm();
                self.treeView.treeview('uncheckAll', [{ silent: true }]);
                self.checkVisibleButtons(node);
                self.updateNumberCheckedMessage();
            },
            onNodeUnselected: function (event, node) {
                self.showHideEditForm();
                self.updateNumberCheckedMessage();
            },
            onNodeChecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('checkNode', [nodeIds, { silent: false }]);
                //}
                //  Check button logic
                self.treeView.treeview('unselectAll', [{ silent: true }]);
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onNodeUnchecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('uncheckNode', [nodeIds, { silent: false }]);
                //}
                //  Check button logic
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onMapBtnClicked: function (event, node) {
                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, FeatureType.Maint]));
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });
        
        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }

        self.updateNumberCheckedMessage();
    }

    public createTreeData = (input: Array<INode>): void => {
        const self = this;
        var inNode = input.find(f => f.featureType == FeatureType.MaintParent);
        if (inNode != null && inNode.nodes != null) {
            inNode.nodes.forEach(i => {
                self.treeData.push(i);
            });
        }

        count(FeatureType.MaintParent);

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }

    public DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
    }

    private ZoomToChecked = (): void => {
        const self = this;

        var findCheckableNodes = function () {
            return self.treeView.treeview('getSelected');
        };
        var checkableNodes: Array<INode> = findCheckableNodes();

        var wktArr = []; var hrefArr = [];
        checkableNodes.forEach(n => {
            // Check if this is a group node, if it is, add all the wKT's below it
            if (n.featureType == FeatureType.TaskGroup && n.nodes != null) {
                n.nodes.forEach(i => { if (i.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(i.wkt); hrefArr.push(i.href); } });
            }
            // If this this is not a group node, then just add it as normal. Check first to see if it is already added though
            if (n.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(n.wkt); hrefArr.push(n.href); };
        });
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, FeatureType.Maint]));
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;

        var lang = window.isSiteInWelsh() == true ? 1 : 0;

        // Add the header to issues only
        var colDef;
        if ($('#tmRadio_ReportedIssues').is(':checked')) {
            colDef = [
                { label: Translations.Lang.ID[lang], value: IssueOrder.MaintCode, size: 1 },
                { label: Translations.Lang.Logged[lang], value: IssueOrder.LogDate, size: 2 },
                { label: Translations.Lang.ReportBy[lang], value: IssueOrder.LogBy, size: 3 },
                { label: Translations.Lang.Type[lang], value: IssueOrder.Type, size: 4 },
                { label: Translations.Lang.Parish[lang], value: IssueOrder.AdminArea, size: 2 }
            ];

        }
        else if ($('#tmRadio_IssueComments').is(':checked')) {
            colDef = [
                { label: Translations.Lang.ID[lang], value: IssueOrder.MaintCode, size: 1 },
                { label: Translations.Lang.Logged[lang], value: IssueOrder.LogDate, size: 2 },
                { label: Translations.Lang.ReportBy[lang], value: null, size: 3 },
                { label: Translations.Lang.Type[lang], value: IssueOrder.Type, size: 4 },
                { label: Translations.Lang.Parish[lang], value: IssueOrder.AdminArea, size: 2 }
            ];
        }

        // Create the header
        self.treeView.treeview('addHeader', {
            cols: colDef,
            currentSortDirection: self.currentSortDirection,
            currentSortOrder: self.currentSortOrder,
            callback: function (order, dir) {
                self.currentSortOrder = order;
                self.currentSortDirection = dir;
                self.GetTreeData();
            }
        });

    }

    public checkVisibleButtons = (selectedNode: INode = null): void => {
        const self = this;
        let nodes: INode[] = self.treeView.treeview('getChecked');
        if (selectedNode != null && nodes.length == 0) nodes.push(selectedNode); // Add the selected node to the list if it is not null

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => { self.actionBtns[k].enable = false; });

        // Then switch on the ones we want depending on the nde type
        if (nodes && nodes.length > 0) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.showmap.enable = true;

            if (nodes.length == 1) {
                self.actionBtns.delete.enable = true;
                self.actionBtns.query.enable = true;
                self.actionBtns.reject.enable = true;
            }
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private showHideEditForm = (): void => {
        const self = this;
   
        // Show the task if only one is selected
        if (self.treeView.treeview('getSelected') && self.treeView.treeview('getSelected').length == 1) {
            let n: INode = self.treeView.treeview('getSelected')[0];
            let filter = $("#submissionViewRadioGroup input[type='radio']:checked").data("filter");
            if (filter.SubmissionFilter == SubmissionFilter.ReportedIssues) {
                self.openSubmissionIssueEditForm(n.href);
            }
            else if (filter.SubmissionFilter == SubmissionFilter.IssueComments) {
                self.openSubmissionIssueCommentForm(n.href);
            }
        }
        else {
            $('#submissionListEditContainer').removeClass('show600');
        }
    }

    public updateNumberCheckedMessage = (): void => {
        let num = this.treeView.treeview('getChecked').length;
        let s = num > 1 ? "s" : "";
        if (num == 0) {
            $('#submissionRecordListNumberCheckedBtn').hide();
        }
        else {
            $('#submissionRecordListNumberCheckedBtn').html(`${num} item${s} selected`);
            $('#submissionRecordListNumberCheckedBtn').show();
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    public updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { $('#recordCount').html(' (' + self.issueCountFromServer + ')'); } else { $('#recordCountIndividual').html(); }
        $('#submissionRecordListShowing').html((self.currentPage + 1).toString());
    }

    private checkFilters = (): void => {
        const self = this;
        if ($('#tmRadio_ReportedIssues').is(':checked')) {
            $('#submissionRecordFilter').find('option').remove().end();
            let filters: Array<IFilterDefinitionModel> = $('#submissionListContainer [data-submissionissuefilters]').data('submissionissuefilters');
            if (filters != null) {
                filters.forEach(f => {
                    $('#submissionRecordFilter').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });
            }
        }
        else if ($('#tmRadio_IssueComments').is(':checked')) {
            $('#submissionRecordFilter').find('option').remove().end();
            let filters: Array<IFilterDefinitionModel> = $('#submissionListContainer [data-submissioncommentfilters]').data('submissioncommentfilters');
            if (filters != null) {
                filters.forEach(f => {
                    $('#submissionRecordFilter').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });
            }
        }
    }

    public resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;
        $('#submissionListEditContainer').removeClass('show600');

        var tree: any = $('#submissionListTreeResults');
        this.treeData = [];
        this.treeView = tree.treeview();
        this.updatePagingUI();
    }

    private getCAMSKeyfromNodes = (): Array<ICAMSKey> => {
        let camsKeys: Array<ICAMSKey> = [];
        let nodes: Array<INode> = this.treeView.treeview('getChecked');
        nodes = nodes.concat(this.treeView.treeview('getSelected'));
        if (nodes && nodes.length) {
            nodes.forEach(n => {
                if (camsKeys.find(c => c.code == n.href) == null) {
                    let camsKey: ICAMSKey = { code: n.href, featureType: n.featureType, wkt: n.wkt, parentCode: n.parentCode, parentFeatureType: n.parentFeatureType };
                    camsKeys.push(camsKey);
                }
            });
        }

        return camsKeys;
    }

    private issueTypeChanged = (): void => {
        // Remove all options
        $('#submissionIssueEditForm #IssueType').find('option').remove().end();

        // Populate the list based on the selected group name
        let issueGroupTypeStr = $('#submissionIssueEditForm #IssueGroupType').children("option:selected").val(); // Get the selected option
        this.issueTypeList.forEach(i => {
            if (i.maintTypeGroup == issueGroupTypeStr) {
                $('#submissionIssueEditForm #IssueType').append($("<option></option>").attr("value", i.maintType).text(i.descr));
            }
        });
    }

    private loadIssueLUTs = (): void => {
        const self = this;
        $.ajax({
            url: '/LUT/GetMaintTypeLUT',
            success: function (data) {
                self.issueTypeList = data;
            },
            error: function (e) {
                console.log("Error getting GetMaintTypeLUT", e);
            }
        });
    }
}




